import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export const useCandidateAuth = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API}/api/candidate/me`, { credentials: "include" });
                if (!res.ok) throw new Error();
                setUser(await res.json());
            } catch {
                navigate("/account/login");
            }
        })();
    }, [navigate]);

    const logout = async () => {
        await fetch(`${API}/api/candidate/logout`, { method: "POST", credentials: "include" });
        navigate("/");
    };

    return { user, logout };
};

export const PortalLoading = () => (
    <div className="flex min-h-screen items-center justify-center bg-ivory">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-forest border-t-transparent" />
    </div>
);
